import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
export const AdminManageOrganizationViewParent = styled(FlexColumnDiv) `
    padding: 24px 0;
    align-items: flex-start;
    gap: 40px;
    flex: 1 0 0;
    align-self: stretch;
`;
